import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { enterprisePath } from './enterprisePath';
import { Button } from 'components/ui/button';
import { enterpriseService } from 'services/enterpriseService';
import { useEnterpriseSession } from './useEnterpriseSession';
export default function EnterpriseDiscovery() {
  const {
    ready: apiReady,
    identity,
    error: sessionError,
  } = useEnterpriseSession();
  const [state, setState] = useState({ accounts: [], authorities: [] });
  useEffect(() => {
    let active = true;
    setState({ accounts: [], authorities: [] });
    if (apiReady)
      Promise.allSettled([
        enterpriseService.discoverAccounts(),
        enterpriseService.authorizations(),
      ]).then(([a, b]) => {
        if (active)
          setState({
            identity,
            accounts: a.status === 'fulfilled' ? a.value.accounts : [],
            accountsUnavailable: a.status === 'rejected',
            authorities: b.status === 'fulfilled' ? b.value : [],
            authoritiesUnavailable: b.status === 'rejected',
          });
      });
    return () => {
      active = false;
    };
  }, [apiReady, identity]);
  if (sessionError)
    return (
      <nav className="mb-5" aria-label="Acceso empresarial">
        <Button variant="secondary" asChild>
          <Link to="/enterprise/empresas">Cuenta empresarial</Link>
        </Button>
      </nav>
    );
  if (!apiReady || state.identity !== identity) return null;
  if (
    !state.accounts.length &&
    !state.authorities.length &&
    !state.accountsUnavailable &&
    !state.authoritiesUnavailable
  )
    return null;
  return (
    <nav className="mb-5 flex flex-wrap gap-3" aria-label="Acceso empresarial">
      {(state.accounts.length > 0 || state.accountsUnavailable) && (
        <Button variant="secondary" asChild>
          <Link
            to={
              state.accounts.length
                ? enterprisePath('/enterprise/empresas', state.accounts[0].id)
                : '/enterprise/empresas'
            }
          >
            Cuenta empresarial
          </Link>
        </Button>
      )}
      {(state.authorities.length > 0 || state.authoritiesUnavailable) && (
        <Button variant="secondary" asChild>
          <Link to="/enterprise-authorizations">
            Autorizaciones empresariales
          </Link>
        </Button>
      )}
    </nav>
  );
}
